import {
  component_styles_default
} from "./chunk.BKUJPVXD.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/message-input/message-input.styles.ts
var message_input_styles_default = r` ${component_styles_default} :host { font-family: var(--sl-font-sans); } .message-input::part(base) { box-shadow: none; border-color: var(--card-border-color); border-radius: 0 0 var(--sl-border-radius-x-large) var(--sl-border-radius-x-large); } .message-input::part(input) { color: var(--sl-input-color); text-overflow: ellipsis; padding: 0 var(--form-control-floating-label-left); } sl-icon-button { padding-right: var(--form-control-slot-margin); } .message-input:focus-within::part(base) { border-color: var(--form-control-focus-border-color); } sl-input::part(input)::placeholder { color: var(--sl-input-placeholder-color); } .message-input sl-icon-button::part(base) { color: var(--sl-color-primary-600); padding: 0; } `;

export {
  message_input_styles_default
};
